// @ts-nocheck
/**
 * One place to store all system static files routes
 */
export const ERROR_IMAGE_ROUTE = '/images/errorImage.png'
export const ERROR_IMAGE_LOCAL_ROUTE = '/theme/assets/images/errorImage.png'
